// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"b0d416e4","640":"91f302c9"}[chunkId] + ".chunk.js";
};